export default class RiskFormAPI {
  constructor(clientId) {
    this.clientId = clientId
    this.baseUrl = `/clients/${clientId}`
  }

  // Récupérer le dernier niveau de risque utilisé
  async getLastRiskLevel() {
    const response = await this._fetch(`${this.baseUrl}/last_risk_level`)
    return response.risk_level_id
  }

  // Récupérer les questions pour un niveau de risque
  async getQuestions(riskLevelId) {
    const response = await this._fetch(`${this.baseUrl}/risk_form_questions?risk_level_id=${riskLevelId}`)
    return response.questions
  }

  // Récupérer les réponses existantes
  async getExistingAnswers(riskLevelId = null) {
    const params = riskLevelId ? `?risk_level_id=${riskLevelId}` : ''
    const response = await this._fetch(`${this.baseUrl}/risk_form_existing_answers${params}`)
    return {
      hasAnswers: response.has_answers,
      answersByRiskLevel: response.answers_by_risk_level,
      firstRiskLevel: response.first_risk_level
    }
  }

  // Sauvegarder les réponses
  async saveAnswers(formData) {
    const response = await this._fetch(`${this.baseUrl}/risk_form_answers`, {
      method: 'POST',
      body: formData
    })
    return response.success
  }

  // Supprimer la fiche de risque (toutes les réponses) du client
  async deleteRiskForm(riskLevelId = null) {
    const params = riskLevelId ? `?risk_level_id=${riskLevelId}` : ''
    const response = await this._fetch(`${this.baseUrl}/risk_form_delete${params}`, {
      method: 'DELETE'
    })
    return response.success
  }

  // Méthode privée pour les requêtes HTTP
  async _fetch(url, options = {}) {
    const defaultOptions = {
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }

    // Ajouter le token CSRF pour toutes les requêtes non-GET (POST, PUT, DELETE, etc.)
    if (options.method && options.method !== 'GET') {
      defaultOptions.headers['X-CSRF-Token'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    }

    try {
      const response = await fetch(url, { ...defaultOptions, ...options })
      
      if (!response.ok) {
        // Essayer de récupérer le message d'erreur du serveur
        let errorMessage = 'Erreur réseau'
        try {
          const errorData = await response.json()
          errorMessage = errorData.error || `Erreur ${response.status}: ${response.statusText}`
        } catch (e) {
          errorMessage = `Erreur ${response.status}: ${response.statusText}`
        }
        throw new Error(errorMessage)
      }
      
      return response.json()
    } catch (error) {
      console.error('Erreur API:', error)
      throw error
    }
  }
} 